import React, { Component } from "react";
import L from 'leaflet'
import { GeoLocation } from 'geodesy-js';
import { Angle, Length } from 'unitsnet-js';
import 'leaflet-rotatedmarker'

class LiveMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boatIcon: '',
            boatMarker: '',
            liveMap: '',
            visibilityCircle: '',
            portCircles: {},
            isFirstLoad: true,
            lastPlacedTrackPoint: '',
            trackPoints: []
        };
    }
    render() {



        if (this.props.boatData) {
            const boat = this.props.boatData;
            const liveMap = this.state.liveMap;



            const latLng = L.latLng(boat.lat, boat.long);

            const boatLocation = new GeoLocation({
                Latitude: Angle.FromDegrees(boat.lat),
                Longitude: Angle.FromDegrees(boat.long),
            });

            const visibility = boat.weather.visibility;

            // this.state.visibilityCircle.setRadius(visibility);
            // this.state.visibilityCircle.setLatLng(latLng);


            const visibilityMargin = 5000; // On est sympa


            const viewCorner1coords = boatLocation.destination(Angle.FromDegrees(-45), Length.FromMeters(visibility + visibilityMargin));
            const viewCorner1 = L.latLng(viewCorner1coords.Latitude.value, viewCorner1coords.Longitude.value)
            const viewCorner2coords = boatLocation.destination(Angle.FromDegrees(135), Length.FromMeters(visibility + visibilityMargin));
            const viewCorner2 = L.latLng(viewCorner2coords.Latitude.value, viewCorner2coords.Longitude.value)

            const bounds = L.latLngBounds(viewCorner1, viewCorner2)


            this.state.boatMarker.setLatLng(latLng);
            this.state.boatMarker.setRotationAngle(boat.bearing);


            liveMap.setMaxBounds(bounds);
            if (this.state.isFirstLoad) {
                liveMap.setView(latLng);
                liveMap.fitBounds(bounds);
                this.setState({ isFirstLoad: false })
            }

            let zoomLevel = this.getZoomLevelFromVisibility(visibility);
            if (window.innerWidth < 768) { // Adjusting min zoom level for mobile view
                zoomLevel = zoomLevel - .4;
            }
            liveMap.setMinZoom(zoomLevel);

            // L.rectangle(bounds, { color: "#ff7800", weight: 1 }).addTo(liveMap);

            const delayBetweenPoints = 15 * 1000; // en ms
            const maxNumberPoints = 30;
            const birthRadius = 20;
            const now = Date.now();
            if (now - this.state.lastPlacedTrackPoint > delayBetweenPoints) {

                if (this.state.trackPoints.length >= maxNumberPoints) {
                    this.state.liveMap.removeLayer(this.state.trackPoints[0]);
                    this.state.trackPoints.shift();
                }
                this.state.trackPoints.push({
                    circle: L.circle(latLng, {
                        radius: birthRadius,
                        fillColor: '#fff',
                        weight: 0,
                        fillOpacity: 1
                    }).addTo(this.state.liveMap),
                    timestamp: now
                });
                this.setState({ lastPlacedTrackPoint: Date.now() });
            }
            for (let i = 0; i < this.state.trackPoints.length; i++) {
                let timeSinceSpawn = now - this.state.trackPoints[i].timestamp;
                let newOpacity = this.range(0, delayBetweenPoints * maxNumberPoints * .5, 1, 0, timeSinceSpawn);
                let newRadius = this.range(0, delayBetweenPoints * maxNumberPoints, birthRadius, 5, timeSinceSpawn);
                // console.log(timeSinceSpawn, delayBetweenPoints * maxNumberPoints, newOpacity.toFixed(2), newRadius.toFixed(2))
                this.state.trackPoints[i].circle.setRadius(newRadius.toFixed(2));
                this.state.trackPoints[i].circle.setStyle({ fillOpacity: newOpacity.toFixed(2) });
            }
        }
        return <div id="liveMap"></div>;
    }
    componentDidMount() {
        this.setState({
            boatIcon: L.icon({
                iconUrl: '../img/boat.svg',
                iconSize: [25, 25],
                iconAnchor: [12.5, 12.5]
            })
        }, () => {
            this.setMap();
        })

    }
    componentDidUpdate(prevProps, prevState, snapshot) {

        // If port list changed, update ports
        if (JSON.stringify(prevProps.portsData) != JSON.stringify(this.props.portsData) && this.props.portsData) {

            let ports = this.props.portsData;
            let boat = this.props.boatData;


            for (let oldPort in this.state.portCircles) {
                this.state.liveMap.removeLayer(this.state.portCircles[oldPort]);
            }

            let newPortCircles = {};
            for (let port of ports) {

                let circleColor = '#3388ff';
                const isInPort = this.checkIfBoatInPort(boat, port)
                if (isInPort) {
                    this.setState({ inPort: port._id })
                    circleColor = '#6ae84e';
                }
                newPortCircles[port._id] = L.circle([port.lat, port.long], { radius: 3000, color: circleColor }).addTo(this.state.liveMap);


            }

            this.setState({ portCircles: newPortCircles })
        }

        // When boat is updated, check if is in port
        if (JSON.stringify(prevProps.boatData) != JSON.stringify(this.props.boatData)) {
            let ports = this.props.portsData;
            let boat = this.props.boatData;

            for (let port of ports) {
                const isInPort = this.checkIfBoatInPort(boat, port)

                let circleColor = '#3388ff';
                if (isInPort) {
                    this.setState({ inPort: port._id })
                    circleColor = '#6ae84e';
                }

                const portcircles = this.state.portCircles;
                if (portcircles[port._id]) {
                    portcircles[port._id].setStyle({ color: circleColor })
                }
            }
        }


    }
    checkIfBoatInPort(boat, port) {

        const boatLocation = new GeoLocation({
            Latitude: Angle.FromDegrees(boat.lat),
            Longitude: Angle.FromDegrees(boat.long),
        });
        const portLocation = new GeoLocation({
            Latitude: Angle.FromDegrees(port.lat),
            Longitude: Angle.FromDegrees(port.long),
        });

        const distance = boatLocation.distance(portLocation);

        if (distance.value <= 3000) {
            // console.log('Boat is in ', port.name);
            return port._id
        } else {

            return null;
        }
    }
    setMap() {
        let layer = new L.tileLayer('https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}{r}.png');


        this.setState({
            liveMap: new L.Map("liveMap", {
                center: new L.LatLng(0, 0),
                zoom: 1,
                // dragging: false,
                zoomControl: false,
                bounceAtZoomLimits: false,
                zoomSnap: 0.1,
                maxBoundsViscosity: 0.9,
                maxZoom: 14,
                //        minZoom: 11
            }).addLayer(layer)
        }, () => {
            this.setState({
                boatMarker: L.marker([0, 0], {
                    icon: this.state.boatIcon
                }).addTo(this.state.liveMap)
            })
        });

    }



    getZoomLevelFromVisibility(visibility) {
        const zoom = (160000 / ((visibility + 4000) * 5)) + 9.7;
        return zoom.toFixed(1);
    }

    lerp = (x, y, a) => x * (1 - a) + y * a;
    clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a));
    invlerp = (x, y, a) => this.clamp((a - x) / (y - x));
    range = (x1, y1, x2, y2, a) => this.lerp(x2, y2, this.invlerp(x1, y1, a));
}

export default LiveMap;
